export default "__VITE_ASSET__c20079cf__"